
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/toplists/[id]",
      function () {
        return require("private-next-pages/destinations/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/toplists/[id]"])
      });
    }
  